export default (number: number) => {
  const factor = 10 ** 2;
  return Math.round(number * factor) / factor;
};
